import type { FunctionComponent, ReactNode } from 'react';

import { AuthProvider } from '../modules/auth/providers/auth.provider';
import { ApiProvider } from '../modules/api/providers/api.provider.tsx';

export interface ProvidersProps {
  readonly children?: ReactNode;
}

export const Providers: FunctionComponent<ProvidersProps> = (props) => {
  const { children } = props;

  return (
    <ApiProvider>
      <AuthProvider>{children}</AuthProvider>
    </ApiProvider>
  );
};
